"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacingValues = void 0;

var styles_1 = require("@material-ui/core/styles");

var materialTheme_1 = __importDefault(require("../themes/materialTheme"));

var parentTheme = styles_1.createMuiTheme(materialTheme_1.default);
exports.spacingValues = ['0', parentTheme.spacing(1) + "px", parentTheme.spacing(2) + "px", parentTheme.spacing(3) + "px", parentTheme.spacing(4) + "px", parentTheme.spacing(5) + "px", parentTheme.spacing(6) + "px", parentTheme.spacing(7) + "px", parentTheme.spacing(8) + "px"];